import {
  buildMetadata,
  formatBuildVersionLabel,
} from "@/features/navigation/buildMetadata";

export function AppVersionFooter() {
  return (
    <footer
      aria-label="Build version"
      className="pointer-events-none fixed bottom-2 right-2 z-30 max-w-[calc(100vw-1rem)] print:hidden"
    >
      <span className="block truncate rounded border border-rule bg-elevated px-2 py-1 font-mono text-[0.625rem] leading-none text-ink-muted">
        {formatBuildVersionLabel(buildMetadata)}
      </span>
    </footer>
  );
}
